import React from 'react';

const MessageContext = React.createContext({ sendChatMessage: () => {} });

export const ContextMessageProvider = MessageContext.Provider;
export const ContextMessageConsumer = MessageContext.Consumer;
